import GeckoTableController from "./gecko_table_controller";
import { EventCurrencyChanged } from "../events";
import { getActiveCurrency } from "../util/currency";
import { formatCurrency } from "../util/currency";

export default class extends GeckoTableController {
  static targets = GeckoTableController.targets.concat(["profitLoss"]);

  connect() {
    window.addEventListener(EventCurrencyChanged, e => {
      this._fetchProfitLoss();
    })
  }

  _fetchProfitLoss() {
    const path = this.tableTarget.getAttribute("data-fetch-path"),
          pathWithParams = `${path}?vs_currency=${getActiveCurrency()}`;

    this._renderLoadingStatus();
    fetch(pathWithParams, { credentials: "same-origin" })
      .then(response => {
        if (response.status != 200) {
          throw new Error("Failed to fetch latest results");
        } else {
          return response.json();
        }
      })
      .then(json => {
        const results = json["data"];
        this._updateProfitLoss(results);
      })
      .catch(error => {
        this._renderError()
      });
  }

  _renderLoadingStatus() {
    const rows = this.profitLossTargets;
    rows.forEach(function(row) {
      row.innerText = "Loading...";
    })
  }

  _updateProfitLoss(results) {
    const rows = this.profitLossTargets;
    rows.forEach(function(row) {
      const tr = row.parentNode,
            upClass = row.getAttribute("data-up-class"),
            downClass = row.getAttribute("data-down-class"),
            portfolioTransactionId = tr.getAttribute("data-portfolio-coin-transaction-id"),
            result = results.filter(r => r.id == portfolioTransactionId)[0];

      row.classList.remove(upClass, downClass);
      if (result) {
        row.classList.remove(upClass, downClass);
        if (result.profit_loss > 0) {
          row.classList.add(upClass);
          row.innerText = `+${formatCurrency(result.profit_loss, getActiveCurrency())}`;
        } else if(result.profit_loss < 0) {
          row.classList.add(downClass);
          row.innerText = `${formatCurrency(result.profit_loss, getActiveCurrency())}`;
        }
      } else {
        row.innerText = "Loading...";
      }
    })
  }

  _renderError() {
    return "Error..."
  }
}